import React, { useEffect } from 'react';
import
{
    Box, CircularProgress,
    ListItem, Card, CardContent
} from '@mui/material';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import { createTheme } from '@mui/material/styles';
const theme = createTheme();
import { makeStyles } from '@mui/styles';
import AgentNotificationList from './agentNotificationList';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';

const useStyles = makeStyles(() => ({
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    rowContent: {
        textAlign: 'center',
    },
    paperContent: {
        boxShadow: 'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
}));

const AgentNotifications = (props) =>
{
    const classes = useStyles();
    const eventInfo = Helper.getStorage('eventInfo');
    const [userModulePermissions, setUserModulePermissions] = React.useState({
        columns: [],
        rows: [],
    });
    const [loading, setLoading] = React.useState(false);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    useEffect(() =>
    {
        getAllData();
    }, []);

    async function getAllData()
    {
        const userModulesInfo = ApiHelper.get(
            APIURLConstants.GET_EVENT_PARTICIPANTS(
                eventInfo.eventID,
                1,
                5000,
                1
            )
        );
        let newUserModulePermissions = {
            columns: [],
            rows: [],
        };
        setLoading(true);
        await Promise.all([userModulesInfo]).then((result) =>
        {
            const users = result[0].data;
            let finalArray = [];
            users.rows.map((item) =>
            {
                if (item.userConnection.length > 0)
                {
                    item.userConnection.map((value) =>
                    {
                        // const newObj = item.userAppNotificationSetting[index]
                        const obj = {
                            agent: item.name,
                            agentID: item.userID,
                            connection: value.name,
                            connectionID: value.userID,
                            isEmail:value.isEmail,
                            isPush:value.isPush,
                            isBlast:value.isBlast,
                        }
                        finalArray.push({ ...obj })
                    })
                }
            })
            
            if (finalArray.length > 0)
            {
                newUserModulePermissions.columns.push({
                    id: 'userName',
                    label: 'Agent',
                    moduleID: 0,
                    showPermission: false,
                    permission: null,
                    align: 'left',
                });
                newUserModulePermissions.columns.push({
                    id: 'role',
                    label: 'Connections',
                    moduleID: 0,
                    showPermission: false,
                    permission: null,
                    align: 'left',
                });
                newUserModulePermissions.columns.push({
                    id: 'tags',
                    label: 'Tags',
                    moduleID: 0,
                    showPermission: false,
                    permission: null,
                    align: 'left',
                });
                newUserModulePermissions.columns.push({
                    id: 'email',
                    label: 'Email',
                    moduleID: 0,
                    showPermission: true,
                    permission: null,
                    align: 'left',
                });
                newUserModulePermissions.columns.push({
                    id: 'mobile',
                    label: 'Push',
                    moduleID: 0,
                    showPermission: true,
                    permission: null,
                    align: 'left',
                });
                newUserModulePermissions.columns.push({
                    id: 'app',
                    label: 'App',
                    moduleID: 0,
                    showPermission: true,
                    permission: null,
                    align: 'left',
                });
                let usersData = [];
                finalArray.map((user) =>
                {
                    let rowObj = {
                        userName: {
                            label: user.agent,
                            agentID: user.agentID,
                            moduleID: 0,
                            showPermission: false,
                            email: user.isEmail ,
                            mobile: user.isPush,
                            app: user.isBlast,
                            showLabel: true,
                            showChips: false,
                            permission: null,
                            align: 'left',
                        },
                        role: {
                            label: user.connection,
                            connectionID: user.connectionID,
                            moduleID: 0,
                            showPermission: false,
                            showLabel: true,
                            showChips: false,
                            permission: null,
                            align: 'left',
                        },
                        tags: {
                            label: user.userTags,
                            moduleID: 0,
                            showPermission: false,
                            showLabel: false,
                            showChips: true,
                            permission: null,
                            align: 'center',
                        },
                        email: {
                            label: 'Email',
                            moduleID: 0,
                            showPermission: true,
                            showLabel: false,
                            showChips: false,
                            permission: user.isEmail? 2: 0,
                            align: 'center',
                        },
                        mobile: {
                            label: 'Mobile',
                            moduleID: 0,
                            showPermission: true,
                            showLabel: false,
                            showChips: false,
                            permission: user.isPush ? 2: 0,
                            align: 'center',
                        },
                        app: {
                            label: 'App',
                            moduleID: 0,
                            showPermission: true,
                            showLabel: false,
                            showChips: false,
                            permission: user.isBlast? 2 : 0,
                            align: 'center',
                        },
                    };
                    usersData.push(rowObj);
                });
                newUserModulePermissions.rows = usersData;
                setUserModulePermissions(newUserModulePermissions);
            }
            setLoading(false);
        });
    }


    return (
        <Box sx={{ width: '100%' }}>
            {loading ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        width: '100%',
                        mt: 10,
                    }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box className="contentBox">
                    {/* <Title title={'Set Permissions'} /> */}
                    {userModulePermissions && userModulePermissions.columns.length > 0 && userModulePermissions.rows.length > 0 ?
                        <AgentNotificationList
                            {...props}
                            data={userModulePermissions}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            getAllData={getAllData}
                        />
                        :
                        <ListItem className={classes.listItemContent}>
                            <Card
                                classes={{ root: classes.paperContent }}
                                sx={{ width: '100%' }}>
                                <CardContent
                                    sx={{ p: 2 }}
                                    className={classes.cardContent}>
                                    <Box className={classes.rowContent}>
                                        Please select the participant and modules for event
                                    </Box>
                                </CardContent>
                            </Card>
                        </ListItem>
                    }
                </Box>
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: false,
                        })
                    }></CustomizedSnackbars>
            )}
        </Box>
    );
};
export default AgentNotifications;